import { Link } from "react-router-dom";
import { Card, CardBody, Col, Input } from "reactstrap";
import { H6, LI, UL } from "../../../../AbstractElements";
import { TasksListTitle } from "../../../../Constants/Constants";
import { TasksListData } from "../../../../Data/General/Dashboard/Default";
import { CommonDropdown } from "../../../CommonComponents/CommonDropdown/CommonDropdown";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";

const TasksList = () => {
  return (
    <Col xl="4" sm="6" className="box-col-4">
      <Card className="active-task">
        <DashboardCommonHeader title={TasksListTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <UL className="simple-list">
            {TasksListData.map((item, index) => (
              <LI className="d-flex align-items-center gap-3" key={index}>
                <span className={`bg-${item.color}`} />
                <div className="flex-shrink-0">
                  <div className="checkbox-checked">
                    <Input type="checkbox" />
                  </div>
                </div>
                <div className="flex-grow-1">
                  <Link to={`${process.env.PUBLIC_URL}/applications/task`}>
                    <H6>{item.title}</H6>
                  </Link>
                  {item.text}
                </div>
                <CommonDropdown days dropdownClass="dropdown-toggle" />
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TasksList;
